import { Button } from '@mui/material';
import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom'
import LogoutIcon from '@mui/icons-material/Logout';

const Signup = (props) => {
    const [credential, setcredential] = useState({name:"",email:"",password:""})
    const history = useNavigate();
  
    const handleSubmit= async(e)=>{
        e.preventDefault(); // to stop relaoding page
        const response = await fetch( "https://backened-8u4s2zadi-jharaghav3209-gmailcom.vercel.app/api/auth", {
            method: 'POST',
            
            headers: {
                'Content-Type': 'application/json',
                
                
            },
            
            body: JSON.stringify({name:credential.name, email:credential.email,password:credential.password })
        });
        const json = await response.json();
        if(json.success){
        localStorage.setItem('token',json.token);
        localStorage.setItem('name',json.pasName);
        history('/');
        props.showAlert("Account is Successfully Created","success");
        }
        else{
            props.showAlert("User  already existed","danger");
        }

    }
    const handleChange=(e)=>{
        setcredential({...credential,[e.target.name] : e.target.value})
    }
  return (
    <div className='container '>
        <form onSubmit={handleSubmit}>
        <div className="mb-3">
    <label htmlFor="exampleInputName" className="form-label">Name</label>
    <input type="name" name='name' className="form-control" id="name" value={credential.name} onChange={handleChange} aria-describedby="emailHelp"/>
    
  </div>
  <div className="mb-3">
    <label htmlFor="email" className="form-label">Email address</label>
    <input type="email"  className="form-control"  id="email"  value={credential.email}onChange={handleChange} aria-describedby="emailHelp"name="email" />
   
  </div>
  <div className="mb-3">
    <label htmlFor="password" className="form-label">Password</label>
    <input type="password"  className="form-control" id="password" name="password" value={credential.password} onChange={handleChange}  />
  </div>
  <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" value="" id="invalidCheck2" required/>
      <label class="form-check-label" for="invalidCheck2">
        Agree to terms and conditions
      </label>
    </div>
  <Button variant="contained" type="submit" className="btn btn-primary" endIcon={<LogoutIcon/>}>SignUp</Button>
 
</form>
    </div>
  )
}

export default Signup